import { useEffect, useState } from "react"
import { defaultCardSelection, GroupHeader, groupSelector, mainHeader, selectHeader, singleAnswerForm } from "./functions"

const options = [
  "Peça Cerâmica",
  "Pastilha",
  "Porcelanato",
  "Pedra Natural",
  "Madeira",
  "Poliestireno",
  "PVC",
  "MDF",
  "MDP",
  "Pintura",
  "Textura Branca + Pintura",
  "Textura Pigmentada",
  "Nenhum",
  "Outro",
  "Seguir descrição do projeto",
  "Definir Posteriormente"
];

const wallsFinishToExclude = [
  "Peça Cerâmica",
  "Pastilha",
  "Porcelanato",
  "Pedra Natural",
  "Ladrilhos Hidráulicos"];


const BaseboardQuestions = ({ walls, onGroupsChange, formData, preGroup, finished }) => {
  const [groups, setGroups] = useState([])
  const [currentGroup, setCurrentGroup] = useState([])
  const [formatPav, setFormatPav] = useState([])
  const [toggle, setToggle] = useState(true)
  const { baseboards: preBase } = formData.roomDefinitions
  const [baseboards, setBaseboards] = useState([])
  const { pavements } = formData
  const [visibleGroups, setVisibleGroups] = useState([])

  const handleGroup = (e) => {
    if (finished) return;
    if (!currentGroup.includes(e)) {
      setCurrentGroup([...currentGroup, e])
    } else {
      setCurrentGroup(currentGroup.filter(i => i !== e))
    }
  }

  const finishGroup = () => {
    setGroups([...groups, { rooms: currentGroup.sort(), type: "", height: "" }])
    setCurrentGroup([])
  }

  useEffect(() => {
    onGroupsChange(groups)

  }, [groups])

  useEffect(() => {
    if (groups.length > 0) {
      const elem = document.getElementById(`rodapes-${groups.length - 1}`);
      if (elem) {
        elem.scrollIntoView({ behavior: "smooth", block: "center" });
      }
    }
  }, [groups.length])

  useEffect(() => {
    const wallsToDelete = walls
      ?.filter(i => wallsFinishToExclude.includes(i.finish))
      .flatMap(i => i.rooms) || [];

    const filteredBaseboards = [...preBase?.filter(i => !wallsToDelete.includes(i))] || [];

    setBaseboards(filteredBaseboards);

    const pavs = pavements.map(i => {
      return {
        pavement: i.pavement,
        rooms: i.rooms.filter(j => filteredBaseboards.includes(j))
      }
    })
    setFormatPav(pavs.filter(i => i.rooms.length > 0));
    setGroups(preGroup || [])
  }, [walls, pavements])


  const checkRemaining = (arr) => {
    const remaining = arr?.filter(i => !groups.flatMap(group => group.rooms).includes(i));
    return remaining;
  }

  const selectAll = () => {
    if (currentGroup.join('') === checkRemaining(baseboards).join('')) {
      setCurrentGroup([])
    } else {
      setCurrentGroup(checkRemaining(baseboards))
    }
  }

  const selectBulk = (priv) => {
    const privAreas = formData.roomDefinitions.privAreas
    if (priv) {
      setCurrentGroup(privAreas);
    } else {
      const common = baseboards.filter(i => !privAreas.includes(i))
      setCurrentGroup(common)
    }
  }

  const handleChanges = (e, idx, field) => {
    if (finished) return;
    const newGroups = [...groups];
    newGroups[idx][field] = e;
    setGroups(newGroups);
  }

  const resetGroup = (idx) => {
    const newGroups = [...groups];
    newGroups.splice(idx, 1);
    setGroups(newGroups);
    setCurrentGroup([]);
  }

  const resetAll = () => {
    setGroups([])
  }

  const handleToggle = (idx) => {
    if (visibleGroups.includes(idx)) {
      setVisibleGroups(visibleGroups.filter(i => i !== idx))
    } else {
      setVisibleGroups([...visibleGroups, idx])
    }
  }

  return <div className="form-section">
    {mainHeader("Rodapés", groups, resetAll, toggle, setToggle)}

    {toggle && <>

      {groups.length > 0 && <>
        {groups.map((i, idx) => {
          return <div id={`rodapes-${idx}`} key={idx}>
            <GroupHeader idx={idx} rooms={i.rooms} handleToggle={handleToggle} active={visibleGroups.includes(idx)} groups={groups} setGroups={setGroups} setCurrentGroup={setCurrentGroup} />
            {visibleGroups.includes(idx) && <div className="group-questions-container">

              {singleAnswerForm("Qual tipo de rodapé nesses ambientes?", options, idx, "type", formData.projRoomFull, "Tipo de Rodapé", groups[idx], handleChanges, finished)}

              <div className='question-container'>
                <label>Qual altura do rodapé nesses ambientes? (cm)</label>
                <input className="margin-tier-1" type='text' placeholder='Altura em CM' value={groups[idx].height} onChange={(e) => handleChanges(e.target.value, idx, 'height')} />
              </div>
            </div>}

          </div>
        })}
      </>}

      {checkRemaining(baseboards).length > 0 && <>
        <label className="margin-tier-2 select-groups-header">Selecionar grupos</label>
        {selectHeader(selectAll, selectBulk)}
      </>}

      {groupSelector(formatPav, groups, currentGroup, handleGroup, finishGroup, baseboards)}
    </>}
  </div>
}

export default BaseboardQuestions;